/* eslint-disable */

import { EQUITY_COLOR_MAP } from './EquityCapChart'

const EquityBreakdownTable = ({ equityCapData, hideTitle = false, hideCard = false }) => {
  // Format currency in Indian number system
  const formatIndianCurrency = (amount) => {
    return new Intl.NumberFormat('en-IN', {
      style: 'currency',
      currency: 'INR',
      maximumFractionDigits: 0,
    }).format(amount)
  }

  // Format percentage to 2 decimal places
  const formatPercentage = (percentage) => {
    return parseFloat(percentage).toFixed(2)
  }

  const rows = [
    { name: 'Large Cap', ...equityCapData.largeCap },
    { name: 'Mid Cap', ...equityCapData.midCap },
    { name: 'Small Cap', ...equityCapData.smallCap },
  ]

  // Calculate total
  const totalAmount = rows.reduce((sum, row) => sum + row.amount, 0)
  const totalPercentage = rows.reduce((sum, row) => sum + row.percentage, 0)

  const content = (
    <>
      {!hideTitle && (
        <div className='px-4 sm:px-6 py-3 sm:py-4 border-b border-gray-200 dark:border-fb-border'>
          <h2 className='text-base sm:text-lg dark:text-fb-strong'>Equity Market Cap Breakdown</h2>
        </div>
      )}

      <div className='overflow-x-auto'>
        <div className='rounded-lg border border-gray-200 overflow-hidden dark:border-fb-border'>
          <table className='w-full'>
            <thead>
              <tr className='bg-gray-50 border-b border-gray-200 dark:bg-fb-muted dark:border-fb-border'>
                <th className='px-4 sm:px-6 py-3 text-left text-xs sm:text-sm text-gray-600 dark:text-fb-secondary'>
                  Asset Category
                </th>
                <th className='px-4 sm:px-6 py-3 text-right text-xs sm:text-sm text-gray-600 dark:text-fb-secondary'>
                  Amount
                </th>
                <th className='px-4 sm:px-6 py-3 text-right text-xs sm:text-sm text-gray-600 whitespace-nowrap dark:text-fb-secondary'>
                  Share (%)
                </th>
              </tr>
            </thead>
            <tbody>
              {rows.map((row, index) => (
                <tr
                  key={row.name}
                  className={`border-b border-gray-100 dark:border-fb-border ${
                    index % 2 === 0
                      ? 'bg-white dark:bg-fb-surface'
                      : 'bg-gray-50/50 dark:bg-fb-raised'
                  }`}
                >
                  <td className='px-4 sm:px-6 py-3 sm:py-4 text-xs sm:text-sm text-gray-900 dark:text-fb-text'>
                    <div className='flex items-center gap-2'>
                      <div
                        className='w-3 h-3 rounded-full flex-shrink-0'
                        style={{ backgroundColor: EQUITY_COLOR_MAP[row.name] || '#6B7280' }}
                      />
                      <span>{row.name}</span>
                    </div>
                  </td>
                  <td className='px-4 sm:px-6 py-3 sm:py-4 text-xs sm:text-sm text-gray-900 text-right tabular-nums dark:text-fb-text'>
                    {formatIndianCurrency(row.amount)}
                  </td>
                  <td className='px-4 sm:px-6 py-3 sm:py-4 text-xs sm:text-sm text-gray-900 text-right tabular-nums dark:text-fb-text'>
                    {formatPercentage(row.percentage)}%
                  </td>
                </tr>
              ))}

              {/* Total Row */}
              <tr className='bg-teal-50 border-t-2 border-teal-200 dark:bg-fb-accentSoft dark:border-fb-accent'>
                <td className='px-4 sm:px-6 py-3 sm:py-4 text-xs sm:text-sm text-gray-900 dark:text-fb-strong'>
                  Total
                </td>
                <td className='px-4 sm:px-6 py-3 sm:py-4 text-xs sm:text-sm text-gray-900 text-right tabular-nums dark:text-fb-strong'>
                  {formatIndianCurrency(totalAmount)}
                </td>
                <td className='px-4 sm:px-6 py-3 sm:py-4 text-xs sm:text-sm text-teal-700 text-right tabular-nums dark:text-fb-accentText'>
                  {formatPercentage(totalPercentage)}%
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </>
  )

  if (hideCard) {
    return content
  }

  return (
    <div className='bg-white rounded-xl shadow-sm border border-gray-200 overflow-hidden dark:bg-fb-surface dark:border-fb-border'>
      {content}
    </div>
  )
}

export default EquityBreakdownTable
